import { render, staticRenderFns } from "./ChangePwdDialog.vue?vue&type=template&id=795b5dd6&scoped=true"
import script from "./ChangePwdDialog.vue?vue&type=script&lang=js"
export * from "./ChangePwdDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangePwdDialog.vue?vue&type=style&index=0&id=795b5dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b5dd6",
  null
  
)

export default component.exports